import _ from "lodash";

export async function sendOpenAIPOST(
  question: string,
  temperature: number,
  key: string
) {
  const controller = new AbortController();

  const response = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${key}`,
    },
    body: JSON.stringify({
      model: "gpt-4o-mini",
      temperature: temperature,
      messages: [{ role: "user", content: question }],
      stream: true,
    }),
    signal: controller.signal,
  });

  return { response, controller };
}

// https://aidaapp.pro:5443
export async function api(address: string, data: any = {}): Promise<any> {
  let output_data = data;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("hmac")) output_data.hmac_received = params.get("hmac");
    if (params.has("shopname")) output_data.shopname = params.get("shopname");
    if (params.has("code")) output_data.code = params.get("code");
    if (params.has("timestamp"))
      output_data.timestamp = params.get("timestamp");
  } catch {
    console.log("params not found!");
  }
  const hostname = `https://aidaai.xyz:5443${address}`;
  const res = await fetch(hostname, {
    method: "POST",
    body: JSON.stringify(output_data),
    headers: { "Content-Type": "application/json" },
  });
  return await res.json();
}
